import { create } from 'zustand';
import i18n from "i18next";

import { apiDomain, basename } from '../setting';
import useModalStore from './useModalStore';
import useAuthStore from './useAuthStore';
import useLoadingStore from './useLoadingStore';
import withErrorHandling from '../function/withErrorHandling';

const useApplySupplementaryStore = create((set, get) => ({
    isValid_emailId: true,
    getAttachIdByEmailId: async (emailId) => {
        const { setLoading } = useLoadingStore.getState();

        const response = await fetch(`${apiDomain}/${basename}/api/preAuthCore/getAttachIdByEmailId?emailId=${emailId}`, {
            method: 'GET',
        });

        if (response.status === 401) { // Unauthorized
            setLoading(false);
            throw new Error('Unauthorized');
        }

        if (!response.ok) {
            setLoading(false);
            throw new Error('Network Error');
        }

        const data = await response.json();

        if (data.status === "FAIL") {
            setLoading(false);

            set({
                isValid_emailId: false,
            });
        } else {
            set({
                attachid: data.attachid,
                fullname: data.fullname,
            });
        }
    },
    fullname: "",
    document: [],
    setDocument: (value) => set({ document: value }),
    addDocument: newState =>
        set(prevState => {
            return {
                document: [...prevState.document, newState]
            }
        }),
    documentError: false,
    setDocumentError: (value) => set({ documentError: value }),
    attachid: "",
    setAttachid: (value) => set({ attachid: value }),
    submitSuppTempRecord: async (emailId) => {
        const { setLoading } = useLoadingStore.getState();
        const { attachid, document } = get();
        const { openModalInfo } = useModalStore.getState();

        if (document.length === 0) {
            set({
                documentError: true,
            });
            return;
        }

        const response = await fetch(`${apiDomain}/${basename}/api/preAuthCore/SubmitSuppTempRecord`, {
            method: 'POST',
            body: JSON.stringify({
                "emailId": emailId,
                "attachid": attachid,
            })
        });

        if (response.status === 401) { // Unauthorized
            setLoading(false);
            throw new Error('Unauthorized');
        }

        if (!response.ok) {
            setLoading(false);
            throw new Error('Network Error');
        }

        // const data = await response.json();

        set({
            document: [],
            documentError: false,
        });

        openModalInfo({
            title: "提交成功",
            text: "感謝你的提交，我們將繼續審批你的申請。"
            // style: { content: { alignItems: "flex-start" } },
        });
    },
}))

export default useApplySupplementaryStore;